import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, Paper, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, Stack, TextField, InputAdornment, Button } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { isEmpty } from "lodash";

import Swal from "sweetalert2";
import { DataContext } from "../../../context/DataContext";
import { getToken } from "../../../api/Account";
import { getRuta, isAccess, simpleMessage } from "../../../helpers/Helpers";

import NoData from "../../../components/NoData";
import { PaginationComponent } from "../../../components/PaginationComponent";
import { deleteRolByIdAsync, getRolListAsync } from "../../../api/Rols";
import { monoFont } from "../../../theme";

const RolList = () => {
  const [rolList, setRolList] = useState([]);

  const [localReload, setLocalReload] = useState(false);
  const { setIsLoading, setIsUnautorized, access } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");

  const withSearch = rolList.filter((val) => {
    if (searchTerm === "") {
      return val;
    } else if (val.id.toString().includes(searchTerm) || val.rolName.toString().includes(searchTerm)) {
      return val;
    }
    return false;
  });

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const result = await getRolListAsync(token);

      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setRolList(result.data.result);
    })();
  }, [localReload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = withSearch.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const onChangeSearch = (val) => {
    setCurrentPage(1);
    setSearchTerm(val);
    paginate(1);
  };

  const deleteUserRol = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "No podras revertir esto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#2979ff",
      cancelButtonColor: "#f50057",

      confirmButtonText: "Eliminar!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await deleteRolByIdAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);
            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }

          setIsLoading(false);
          setLocalReload(!localReload);
          Swal.fire("Eliminado!", "Rol Eliminado.", "success");
        })();
      }
    });
  };

  return (
    <div>
      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "stretch", sm: "center" }} spacing={1.5} sx={{ marginBottom: "18px" }}>
        <TextField
          size="small"
          onChange={(e) => onChangeSearch(e.target.value.toUpperCase())}
          value={searchTerm}
          placeholder="Buscar rol..."
          sx={{ width: { xs: "100%", sm: 280 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ fontSize: 19, color: "text.disabled" }} />
              </InputAdornment>
            ),
          }}
        />

        {isAccess(access, "SECURITY CREATE") ? (
          <Button onClick={() => navigate(`${ruta}/addrol`)} startIcon={<AddRoundedIcon />} variant="contained" color="primary">
            Agregar rol
          </Button>
        ) : null}
      </Stack>

      {isEmpty(currentItem) ? (
        <NoData />
      ) : (
        <Paper sx={{ overflow: "hidden" }}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Nombre del rol</TableCell>
                  {isAccess(access, "SECURITY UPDATE") || isAccess(access, "SECURITY DELETE") ? <TableCell align="center">Acciones</TableCell> : null}
                </TableRow>
              </TableHead>

              <TableBody>
                {currentItem.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell sx={{ fontFamily: monoFont, color: "text.disabled" }}>{row.id}</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>{row.rolName}</TableCell>

                    {isAccess(access, "SECURITY UPDATE") || isAccess(access, "SECURITY DELETE") ? (
                      <TableCell align="center">
                        <Stack direction={"row"} spacing={0.5} justifyContent="center">
                          {isAccess(access, "SECURITY UPDATE") ? (
                            <IconButton size="small" onClick={() => navigate(`${ruta}/rol/${row.id}`)} title="Permisos">
                              <TuneRoundedIcon sx={{ fontSize: 17 }} />
                            </IconButton>
                          ) : null}

                          {isAccess(access, "SECURITY DELETE") ? (
                            <IconButton size="small" sx={{ color: "error.main" }} onClick={() => deleteUserRol(row)} title="Eliminar">
                              <DeleteRoundedIcon sx={{ fontSize: 17 }} />
                            </IconButton>
                          ) : null}
                        </Stack>
                      </TableCell>
                    ) : null}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ padding: "10px 20px 14px" }}>
            <PaginationComponent data={withSearch} paginate={paginate} itemsperPage={itemsperPage} />
          </Box>
        </Paper>
      )}
    </div>
  );
};

export default RolList;
